import ArrowRight from '@/assets/icons/ArrowRight.svg';
import { useDataLayer } from '@/hooks/useDataLayer';
import type { Image, PromoBadge as Badge } from '@/types';
import { CarouselItem } from './CarouselItem';
import * as Styled from './ImageCarousel.styled';

interface ImageCarouselProps {
  images?: Image[];
  isBook: boolean;
  isWideScreen: boolean;
  itemsPerPage: number;
  offset?: number;
  promoBadge?: Badge;
}

export const ImageCarousel = ({
  images,
  isBook,
  isWideScreen,
  itemsPerPage,
  offset,
  promoBadge,
}: ImageCarouselProps) => {
  const { mediaInteract } = useDataLayer();

  return images ? (
    <Styled.Carousel
      aria-label="Product images"
      itemsPerPage={itemsPerPage}
      loop="infinite"
      onActivePageIndexChange={({ index }) =>
        mediaInteract('image-carousel', 'navigate', index)
      }
      spaceBetweenItems={isWideScreen ? undefined : '16px'}
    >
      <Styled.Main>
        {images?.map(image => (
          <CarouselItem
            image={image}
            isBook={isBook}
            key={image.mainSrc ?? image.videoSrc}
            offset={offset}
            promoBadge={promoBadge}
          />
        ))}
      </Styled.Main>
      {/* The buttons don't work as one might expect when there are 2 or more
          items per page, so best just to hide them. */}
      {itemsPerPage < 2 ? (
        <Styled.ButtonsWrapper>
          <>
            {isWideScreen ? (
              <Styled.ButtonStep dir="prev">
                <ArrowRight />
              </Styled.ButtonStep>
            ) : null}

            <Styled.Buttons>
              {({ index }) => (
                <Styled.Button index={index}>
                  {isWideScreen ? (
                    <img
                      alt={images[index].altText ?? ''}
                      loading="lazy"
                      src={images[index].mainSrc ?? ''}
                    />
                  ) : null}
                </Styled.Button>
              )}
            </Styled.Buttons>

            {isWideScreen ? (
              <Styled.ButtonStep dir="next">
                <ArrowRight />
              </Styled.ButtonStep>
            ) : null}
          </>
        </Styled.ButtonsWrapper>
      ) : null}
    </Styled.Carousel>
  ) : null;
};
